import { cn } from '@/platform/lib/utils';
import { ArrowPathIcon } from '@heroicons/react/20/solid';

const sizes = {
    sm: 'size-4',
    md: 'size-6',
    lg: 'size-8',
};

const Loader = ({ size = 'md', label, className, ...props }) => (
    <span
        role='status'
        className={cn(
            'inline-flex items-center gap-x-2 text-sm text-gray-500',
            className
        )}
        {...props}
    >
        <ArrowPathIcon
            className={cn('animate-spin', sizes[size] ?? sizes.md)}
            aria-hidden='true'
        />
        <span className={cn(!label && 'sr-only')}>{label ?? 'Laden...'}</span>
    </span>
);

export default Loader;
